module.exports = __webpack_public_path__ + "img/arm-header-icons-02.84bceff7.svg";